// extracted by mini-css-extract-plugin
export default {"tabs":"ReservoirSetting_tabs__x-wD1","parentTabs":"ReservoirSetting_parentTabs__uDkls"};